module.exports = __webpack_public_path__ + "img/load-2-1.44444b78.png";